import { httpClient } from './api';

export interface UserSettings {
  dashboard?: {
    kpiOrder?: Array<number | string>;
    widgetLayouts?: Record<string, Array<{
      i: string;
      x: number;
      y: number;
      w: number;
      h: number;
      minW?: number;
      minH?: number;
    }>>;
    widgetVisibility?: Record<string, boolean>;
    widgetCollapsed?: Record<string, boolean>;
    compactMode?: boolean;
  };
}

export const getUserSettings = async (): Promise<UserSettings> => {
  const res = await httpClient<{ settings: UserSettings }>('/api/settings/user');
  if (res.error) return {};
  return res.data?.settings || {};
};

export const saveUserSettings = async (settings: UserSettings): Promise<UserSettings> => {
  const res = await httpClient<{ settings: UserSettings }>('/api/settings/user', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ settings }),
  });
  if (res.error) throw new Error(res.error);
  return res.data?.settings || {};
};


